module.exports = __webpack_public_path__ + "img/map.75cad08d.svg";